import React, { useEffect } from 'react';
import { Toast } from 'react-bootstrap';
import './CommonToast.css';

const CommonToast = ({ show, message, onClose, isError }) => {
  // Set green for success, red for error
  const toastStyle = isError
    ? { backgroundColor: 'red', color: 'white' }
    : { backgroundColor: 'green', color: 'white' };

  useEffect(() => {
    let timer;
    if (show) {
      timer = setTimeout(() => {
        onClose();
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [show, onClose]);

  return (
    <div>
      <Toast className='common-toast' show={show} style={toastStyle}>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
};

export default CommonToast;    